package com.wintermar.inspection.feature.util.expect_init

import com.wintermar.inspection.feature.domain.usecase.reference.GetProfileUseCase

actual suspend fun processGetProfile(getProfileUseCase: GetProfileUseCase) {
    getProfileUseCase().collect {
        // no-op
    }
}
